/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/control-has-associated-label */
import {
  Alert,
  Avatar,
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid, InputAdornment, InputLabel, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, MenuItem, Paper, Select, TextField, Typography, TablePagination,
  Autocomplete,
  IconButton
} from '@mui/material';
import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import SelectIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import states from 'src/utils/states';
import { useNavigate } from 'react-router';

const QuickOrderDetails = (props) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState({
    name: '',
    order_number: '',
    alias: '',
    phone: '',
    document_type_id: '',
    document: '',
    city: '',
    state: '',
    product_name: '',
    code: '',
    model: '',
    brand: '',
    tension: '220V',
    nf: '',
    date_nf: '',
    purchased: '',
    observation: '',
    client_id: null
  });
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [fieldsValidation, setFieldsValidation] = useState({
    client_id: false,
    order_number: false,
    name: false,
    phone: false,
    document_type_id: false,
    city: false,
    state: false,
    product_name: false,
    model: false,
    brand: false,
    tension: false,
  });

  // Estados dedicados aos ficheiros
  const [productImage, setProductImage] = useState(null);
  const [images, setImages] = useState([]);

  const {
    searchClients,
    paginate,
    clients,
    typeDocuments,
    notifyMessageError,
    saveform,
    findByPhoneClient
  } = props;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    paginate((newPage + 1));
  };

  const hasErrorFields = () => {
    let hasError = false;
    const validation = { ...fieldsValidation };

    Object.keys(fieldsValidation).forEach((key) => {
      if (!selectedValue[key]) {
        hasError = true;
        validation[key] = true;
      } else {
        validation[key] = false;
      }
    });

    if (validation.client_id) {
      if (!validation.name) {
        validation.client_id = false;
      }
    }

    hasError = false;
    Object.keys(fieldsValidation).forEach((key) => {
      if (validation[key]) {
        hasError = true;
      }
    });

    setFieldsValidation(validation);

    return hasError;
  };

  useEffect(() => {
    if (typeDocuments.data && typeDocuments.data.length > 0) {
      setSelectedValue((prevState) => ({
        ...prevState,
        typeDocument: typeDocuments.data[0].id,
      }));
    }
  }, [typeDocuments]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setSelectedValue((prevState) => ({
      ...prevState,
      [name]: value.toUpperCase(),
    }));
  };

  // Manipulação da imagem de cadastro do produto (Única)
  const handleProductFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setProductImage(event.target.files[0]);
    }
  };

  // Manipulação das imagens de entrada da ordem (Múltiplas)
  const handleOrderFilesChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setImages((prevImages) => [...prevImages, ...files]);
    }
  };

  const handleRemoveImage = (indexToRemove) => {
    setImages((prevImages) => prevImages.filter((_, index) => index !== indexToRemove));
  };

  const isValidPhone = (contact) => {
    const cleaned = contact.replace(/[\s()-]/g, '');
    const phoneRegex = /^(\d{10}|\d{11})$/;
    return phoneRegex.test(cleaned);
  };

  const handleSelectClient = (client) => {
    let phone = '';
    if (client.contacts.length > 0) {
      client.contacts.forEach((contact) => {
        if (isValidPhone(contact.contact)) {
          phone = contact.contact;
        }
      });
    }

    let currentState = '';
    states.forEach((state) => {
      if (state.sigla === client.state) {
        currentState = state.sigla;
      }
    });

    setSelectedValue((prevState) => ({
      ...prevState,
      client_id: client.id,
      alias: client.alias,
      name: client.name,
      document_type_id: client.documentType.id,
      document: client.document,
      phone,
      state: currentState,
      city: client.city
    }));
    setOpen(false);
  };

  const searchClient = async () => {
    setLoading(true);
    if (selectedValue.name === '') {
      setPage(0);
    }
    await searchClients({ param: selectedValue.name });
    handleOpen();
    setLoading(false);
  };

  const searchClientAlias = async () => {
    setLoading(true);
    if (selectedValue.alias === '') {
      setPage(0);
    }
    await searchClients({ alias: selectedValue.alias });
    handleOpen();
    setLoading(false);
  };

  const searchClientByDocument = async () => {
    setLoading(true);

    if (selectedValue.document_type_id === '') {
      notifyMessageError('Pesquisar', 'Informe o tipo de documento');
      setLoading(false);
      return;
    }
    if (selectedValue.document === '') {
      notifyMessageError('Pesquisar', 'Informe o número do documento');
      setLoading(false);
      return;
    }

    await searchClients({ document_type_id: selectedValue.document_type_id, document: selectedValue.document });
    handleOpen();
    setLoading(false);
  };

  const clearClientId = async () => {
    if (selectedValue.client_id) {
      setSelectedValue((prevState) => ({
        ...prevState,
        client_id: null,
      }));
    }
  };

  const handleSubmit = async () => {
    try {
      if (!hasErrorFields()) {
        const formData = new FormData();
        Object.entries(selectedValue).forEach(([key, value]) => {
          if (value != null) {
            formData.append(key, value);
          }
        });

        // 1. Envia a imagem do produto usando a chave 'image'
        if (productImage) {
          formData.append('image', productImage);
        }

        // 2. Envia o lote de imagens da ordem usando o array 'images[]'
        if (images.length > 0) {
          images.forEach((file) => {
            formData.append('images[]', file);
          });
        }

        const response = await saveform(formData);
        if (response && response.status === 200) {
          notifyMessageError('Sucesso', 'Ordem criada com sucesso');
          setTimeout(() => {
            navigate('/app/orders', { replace: true });
          }, 1800);
        } else {
          notifyMessageError('Erro', response.data.message || 'Erro ao criar a ordem');
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePhoneBlur = async (event) => {
    const { value } = event.target;
    if (!selectedValue.client_id && value) {
      const client = await findByPhoneClient(value);
      if (client) {
        handleSelectClient(client);
      }
    }
  };

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Selecione um Cliente</DialogTitle>
        <DialogContent>
          <List>
            {clients.data && clients.data.length > 0
              ? clients.data.map((client) => (
                <ListItem key={client.id}>
                  <ListItemText
                    primary={`${client.name}`}
                    secondary={(
                      <>
                        <Typography variant="body2" color="textSecondary">
                          Apelido:
                          {' '}
                          {client.alias}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {client.documentType.name}
                          {' '}
                          {' - '}
                          {' '}
                          {client.document}
                        </Typography>
                      </>
                    )}
                  />
                  <ListItemSecondaryAction>
                    <Button
                      variant="contained"
                      startIcon={<SelectIcon />}
                      onClick={() => handleSelectClient(client)}
                    >
                      Selecionar
                    </Button>
                  </ListItemSecondaryAction>
                </ListItem>
              )) : (
                <Alert severity="warning">
                  <center>
                    <Typography> Nenhum Cliente Encontrado </Typography>
                  </center>
                </Alert>
              )}
          </List>
          {clients.meta && clients.meta.total > 0 && (
            <TablePagination
              component="div"
              count={clients.meta.total}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[]}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose} color="secondary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <Grid container>
        <Paper
          elevation={3}
          sx={{
            p: 2, borderRadius: 2, position: 'relative', mb: 2, width: '100%'
          }}
        >
          <Grid container>
            <Grid item xs={12} sx={{ p: 1 }}>
              <Typography variant="h1">Ordem</Typography>
            </Grid>
            <Grid item xs={12} md={3} lg={3} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Número da Ordem</Typography>
              <TextField
                onChange={handleChange}
                name="order_number"
                value={selectedValue.order_number}
                fullWidth
              />
              {fieldsValidation.order_number && <Alert severity="error">Campo Obrigatório</Alert>}
            </Grid>
          </Grid>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            p: 2, borderRadius: 2, position: 'relative', mb: 2, width: '100%'
          }}
        >
          <Grid container>
            <Grid item xs={12} sx={{ p: 1 }}>
              <Typography variant="h1">Cliente</Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={4} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Nome do Cliente</Typography>
              <TextField
                fullWidth
                required
                onChange={(event) => {
                  handleChange(event);
                  clearClientId();
                }}
                name="name"
                value={selectedValue.name}
                InputProps={{
                  endAdornment: (
                    <InputAdornment onClick={searchClient} sx={{ cursor: 'pointer' }} position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
              {fieldsValidation.name && <Alert severity="error">Campo Obrigatório</Alert>}
            </Grid>
            <Grid item xs={12} md={4} lg={4} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Apelido</Typography>
              <TextField
                onChange={(event) => {
                  handleChange(event);
                  clearClientId();
                }}
                name="alias"
                value={selectedValue.alias}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment onClick={searchClientAlias} sx={{ cursor: 'pointer' }} position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Telefone</Typography>
              <InputMask
                mask="(99) 99999-9999"
                maskChar=" "
                name="phone"
                onBlur={handlePhoneBlur}
                onChange={handleChange}
                value={selectedValue.phone}
              >
                {(inputProps) => <TextField {...inputProps} label="Telefone" variant="outlined" fullWidth />}
              </InputMask>
              {fieldsValidation.phone && <Alert severity="error">Campo Obrigatório</Alert>}
            </Grid>
            <Grid item xs={12} md={3} lg={3} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Tipo de Documento</Typography>
              <FormControl fullWidth>
                <Select
                  value={selectedValue.document_type_id}
                  name="document_type_id"
                  onChange={(e) => setSelectedValue({ ...selectedValue, document_type_id: e.target.value })}
                >
                  {typeDocuments.data && typeDocuments.data.length > 0 && typeDocuments.data.map((type) => (
                    <MenuItem key={`document-${type.id}`} value={type.id}>{type.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              {fieldsValidation.document_type_id && <Alert severity="error">Campo Obrigatório</Alert>}
            </Grid>
            <Grid item xs={12} md={3} lg={3} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Documento</Typography>
              <TextField
                onChange={(event) => {
                  handleChange(event);
                  clearClientId();
                }}
                name="document"
                value={selectedValue.document}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment onClick={searchClientByDocument} sx={{ cursor: 'pointer' }} position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
              {fieldsValidation.document && <Alert severity="error">Campo Obrigatório</Alert>}
            </Grid>
            <Grid item xs={12} md={3} lg={3} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Selecione um Estado</Typography>
              <FormControl fullWidth>
                <Autocomplete
                  options={states}
                  getOptionLabel={(option) => option.nome}
                  value={states.find((estado) => estado.sigla === selectedValue.state) || null}
                  onChange={(event, newValue) => setSelectedValue({
                    ...selectedValue,
                    state: newValue ? newValue.sigla : '',
                  })}
                  renderInput={(params) => (
                    <TextField {...params} label="Estado" variant="outlined" />
                  )}
                  isOptionEqualToValue={(option, value) => option.sigla === value.sigla}
                  fullWidth
                />
                {fieldsValidation.state && <Alert severity="error">Campo Obrigatório</Alert>}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3} lg={3} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Cidade</Typography>
              <TextField
                onChange={handleChange}
                name="city"
                value={selectedValue.city}
                fullWidth
              />
              {fieldsValidation.city && <Alert severity="error">Campo Obrigatório</Alert>}
            </Grid>
          </Grid>
        </Paper>

        <Paper
          elevation={3}
          sx={{
            p: 2, borderRadius: 2, position: 'relative', width: '100%'
          }}
        >
          <Grid container>
            <Grid item xs={12} sx={{ p: 1 }}>
              <Typography variant="h1">Produto</Typography>
            </Grid>
            <Grid item xs={12} md={8} lg={8} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Nome do Produto</Typography>
              <TextField
                onChange={handleChange}
                name="product_name"
                value={selectedValue.product_name}
                fullWidth
              />
              {fieldsValidation.product_name && <Alert severity="error">Campo Obrigatório</Alert>}
            </Grid>
            <Grid item xs={12} md={4} lg={4} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Código Identificador</Typography>
              <TextField
                onChange={handleChange}
                name="code"
                value={selectedValue.code}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Modelo</Typography>
              <TextField
                onChange={handleChange}
                name="model"
                value={selectedValue.model}
                fullWidth
              />
              {fieldsValidation.model && <Alert severity="error">Campo Obrigatório</Alert>}
            </Grid>
            <Grid item xs={12} md={4} lg={4} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Marca</Typography>
              <TextField
                onChange={handleChange}
                name="brand"
                value={selectedValue.brand}
                fullWidth
              />
              {fieldsValidation.brand && <Alert severity="error">Campo Obrigatório</Alert>}
            </Grid>
            <Grid item xs={12} md={4} lg={4} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Selecione a Tensão</Typography>
              <FormControl fullWidth>
                <InputLabel id="tensao-select-label">Tensão</InputLabel>
                <Select
                  labelId="tensao-select-label"
                  value={selectedValue.tension}
                  name="tension"
                  onChange={(e) => setSelectedValue({ ...selectedValue, tension: e.target.value })}
                  label="Tensão"
                >
                  <MenuItem value="127V">127V</MenuItem>
                  <MenuItem value="220V">220V</MenuItem>
                  <MenuItem value="BIVOLT">BIVOLT (AMBAS TENSÕES)</MenuItem>
                  <MenuItem value="COMBUSTAO">COMBUSTÃO</MenuItem>
                  <MenuItem value="DESCONHECIDA">DESCONHECIDA</MenuItem>
                </Select>
              </FormControl>
              {fieldsValidation.tension && <Alert severity="error">Campo Obrigatório</Alert>}
            </Grid>
            <Grid item xs={12} md={4} lg={4} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Nota Fiscal</Typography>
              <TextField
                onChange={handleChange}
                name="nf"
                value={selectedValue.nf}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Data de Emissão da Nota Fiscal</Typography>
              <TextField
                fullWidth
                label="Entrada da Ordem"
                name="date_nf"
                type="date"
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                value={selectedValue.date_nf}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4} sx={{ p: 1 }}>
              <Typography variant="body1" gutterBottom>Onde o produto foi vendido</Typography>
              <TextField
                onChange={handleChange}
                name="purchased"
                value={selectedValue.purchased}
                fullWidth
              />
            </Grid>

            {/* SEÇÃO 1: FOTO EXCLUSIVA DO PRODUTO (Para o Cadastro) */}
            <Grid item xs={12} md={6} sx={{ p: 1, mt: 2 }}>
              <Typography variant="body1" gutterBottom sx={{ fontWeight: 'bold' }}>
                Foto Principal do Produto (Cadastro)
              </Typography>
              <Button component="label" variant="contained" color="info" fullWidth>
                Selecionar Imagem do Produto
                <input type="file" accept="image/*" hidden onChange={handleProductFileChange} />
              </Button>
              {productImage ? (
                <Grid
                  container
                  alignItems="center"
                  sx={{
                    mt: 2, p: 1, border: '1px dashed #0288d1', borderRadius: 1
                  }}
                >
                  <Grid item>
                    <Avatar variant="square" src={URL.createObjectURL(productImage)} sx={{ width: 50, height: 50, borderRadius: 1 }} />
                  </Grid>
                  <Grid item sx={{ pl: 2 }}>
                    <Typography variant="body2">{productImage.name}</Typography>
                  </Grid>
                </Grid>
              ) : (
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>Nenhuma imagem do produto anexada.</Typography>
              )}
            </Grid>

            {/* SEÇÃO 2: MÚLTIPLAS FOTOS DA ORDEM (Condições Físicas) */}
            <Grid item xs={12} md={6} sx={{ p: 1, mt: 2 }}>
              <Typography variant="body1" gutterBottom sx={{ fontWeight: 'bold' }}>
                Anexar Condições Físicas (Múltiplas Fotos da Ordem)
              </Typography>
              <Button component="label" variant="contained" fullWidth>
                Selecionar Fotos de Entrada
                <input type="file" accept="image/*" multiple hidden onChange={handleOrderFilesChange} />
              </Button>

              <Typography variant="body1" sx={{ mt: 1 }}>
                {images.length > 0 ? `${images.length} foto(s) de entrada selecionada(s)` : 'Nenhuma foto anexada'}
              </Typography>

              {images.length > 0 && (
                <List sx={{
                  maxHeight: 200, overflow: 'auto', bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #ddd', mt: 1
                }}
                >
                  {images.map((file, index) => (
                    <ListItem
                      // eslint-disable-next-line react/no-array-index-key
                      key={`img-${file.name}-${index}`}
                      secondaryAction={(
                        <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveImage(index)}>
                          <DeleteIcon color="error" />
                        </IconButton>
                      )}
                    >
                      <ListItemAvatar>
                        <Avatar
                          variant="square"
                          src={URL.createObjectURL(file)}
                          alt={file.name}
                          sx={{ p: 0.5, width: 50, height: 50 }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        sx={{ pl: 2 }}
                        primary={file.name}
                        secondary={`Tamanho: ${(file.size / 1024).toFixed(2)} KB`}
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </Grid>
          </Grid>
        </Paper>

        <Paper
          elevation={3}
          sx={{
            p: 2, borderRadius: 2, position: 'relative', mt: 3, width: '100%'
          }}
        >
          <Grid container spacing={2}>
            <Grid item lg={12}>
              <Typography variant="h1">Detalhes do Problema</Typography>
            </Grid>
            <Grid item xs={12} sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="body1" gutterBottom>Descrição do Problema</Typography>
              <TextField
                multiline
                name="observation"
                value={selectedValue.observation}
                onChange={handleChange}
                fullWidth
                minRows={5}
                maxRows={10}
                sx={{ flexGrow: 1, textarea: { height: '100%', resize: 'vertical' } }}
              />
              {fieldsValidation.observation && <Alert severity="error" sx={{ mt: 1 }}>Campo Obrigatório</Alert>}
            </Grid>
          </Grid>
        </Paper>

        <Grid item lg={12} sx={{ pt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              height: 60,
              width: 200,
              backgroundColor: 'green',
              '&:hover': { backgroundColor: 'darkgreen' },
            }}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

QuickOrderDetails.propTypes = {
  typeDocuments: PropTypes.any.isRequired,
  searchClients: PropTypes.func.isRequired,
  saveform: PropTypes.func,
  notifyMessageError: PropTypes.func,
  findByPhoneClient: PropTypes.func,
  paginate: PropTypes.func,
  clients: PropTypes.any,
};

export default QuickOrderDetails;
